import { Checkbox, InputBase as TextField } from '@material-ui/core';
import React, { useState } from 'react';
import {Fade} from "react-reveal"
import { useHistory } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import Head from '../Head';
import { useFunctions } from "../../context/FunctionsContext"
import { db } from '../../config/Firebase';
import { Alert } from '@material-ui/lab';
import Button from '../utils/Button';


const Payment = () => {
  const { payment_checkboxes } = useData();
  const { push } = useHistory()
  const { Refs,allInputs,GetValues } = useFunctions();
  const [error,setError] = useState(false)
  const [loading,setLoading] = useState(false)
  const refs = new Refs([],allInputs.payments.inputs);
  class Payment {
    constructor(pay= (payment_checkboxes.data||[])){
      pay.forEach(el=> {
        this[el.id] = false
      })
    }
  }
  const onSubmit = async (e)=>{
    try{
      setLoading(true)
      e.preventDefault();
      await db.collection("payments").doc().set({...new GetValues(refs),time: Date.now()});
      setLoading(false);
      push("/thankyou")
    } catch(err){
      setLoading(false);
      setError(err)
    }
  }
  const [checked,setChecked] = useState({...new Payment(payment_checkboxes.data)})
  return (
    <form onSubmit={onSubmit} className="payment container py-5">
      <Head title="Payment" />
      <Fade left>
        <div >
          <TextField  inputRef={refs.name.ref} className="pay_textfield my-2 shadow px-4 py-3 rounded-corners" placeholder="Name" required variant="outlined" color="primary" fullWidth />
        </div>
        <div >
          <TextField  inputRef={refs.mobile_number.ref} className="pay_textfield my-2 shadow px-4 py-3 rounded-corners" placeholder="Mobile Number" required variant="outlined" color="primary" fullWidth />
        </div>
        <div >
          <TextField  inputRef={refs.name_of_influencer.ref} className="pay_textfield my-2 shadow px-4 py-3 rounded-corners" placeholder="Name of Influencer" required variant="outlined" color="primary" fullWidth />
        </div>
        <div >
          <TextField  inputRef={refs.date_time_of_event.ref} rows={5} rowsMax={7} multiline className="pay_textfield my-2 shadow px-4 py-3 rounded-corners" placeholder="Date & Time of the Event" required variant="outlined" color="primary" fullWidth />
        </div>
      </Fade>
      <h5 className="my-3">By Clicking the Submit button I hereby agree to and accept the following terms & conditions below:</h5>
      {(payment_checkboxes?.data||[]).map((el,i)=> <label key={i} htmlFor={el.id} className="my-2 d-flex align-items-center">
        <Checkbox required onChange={(e)=> setChecked((c)=> ({...c,[el.id]: e.target.checked}))} checked={checked[el.id]} id={el.id} color="primary" />
        <label htmlFor={el.id} dangerouslySetInnerHTML={{__html: el.term}} />
      </label>)}
      <Button color="primary" type="submit" disabled={!Object.values({...checked}).every(Boolean) || loading} variant="contained">Submit</Button>
      {error && <Alert severity="error"> {error.message} </Alert>}
    </form>
  );
};

export default Payment;